<template>
  <span class="brand" :class="{ large }">
    <svg class="mark" viewBox="0 0 64 64" aria-hidden="true">
      <defs><clipPath :id="clip"><rect width="64" height="64" rx="14" /></clipPath></defs>
      <g :clip-path="`url(#${clip})`">
        <rect width="64" height="64" fill="#1f1e1d" />
        <path d="M0 45 L15 45 A39.20 39.20 0 0 0 54.79 22 L64 22 V64 H0 Z" fill="#e9dcc3" />
        <path d="M15 45 L33 22 L54.79 22 A39.20 39.20 0 0 1 15 45 Z" fill="#c6613f" transform="rotate(7 19 6)" />
      </g>
    </svg>
    <span class="word" translate="no">SlipSurface</span>
    <span class="iq" translate="no">IQ</span>
  </span>
</template>

<script setup>
defineProps({ large: { type: Boolean, default: false } })
const clip = `brand-${Math.random().toString(36).slice(2, 8)}`
</script>

<style scoped>
.brand {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  line-height: 1;
}

.mark {
  width: 28px;
  height: 28px;
  flex: none;
}

.word {
  font-weight: 600;
  letter-spacing: -0.01em;
}

.iq {
  display: inline-block;
  padding: 3px 6px 2px;
  border-radius: 4px;
  background: #c6613f;
  color: #fff;
  font-size: 0.62em;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.large {
  gap: 12px;
}

.large .mark {
  width: 44px;
  height: 44px;
}

.large .word {
  font-size: 30px;
}
</style>
